import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "member-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "member-form" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { memberGet, memberPatch } from "@/common/api/rest/member";

import type { MemberFullType, MemberPayloadType } from "@/common/types/member";

import { PanelTheme } from "@/common/themes";
import {
  baseAvatar,
  baseInput,
  baseSelect,
  breadcrumbSimple,
  tabMenu,
} from "@/common/components";

type TabActiveType = "edit" | "cv";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const member = ref<MemberFullType | null>(null);
const memberFullName = ref<string>("");

const memberId = computed(() => route.params.member as string);

const breadcrumbList = computed(() => [
  {
    key: "members",
    label: t("common.labels.members"),
    url: "/members",
  },
  {
    key: "member",
    label: `${member.value?.profile?.first_name ?? ""} ${member.value?.profile?.last_name ?? ""}`,
  },
  {
    key: "edit",
    label: t("common.labels.edit"),
  },
]);

const tabList = computed(() => [
  {
    key: "edit",
    label: t("common.labels.member").toUpperCase(),
  },
  {
    key: "cv",
    label: t("common.labels.cv").toUpperCase(),
  },
]);

const activeOptions = computed(() => [
  { option: t("common.labels.active"), value: true },
  { option: t("common.labels.inactive"), value: false },
]);

function fetchData() {
  memberGet(memberId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        member.value = data;
        memberFullName.value = `${data.profile.first_name} ${data.profile.last_name}`;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateMember(key: keyof MemberPayloadType) {
  const payload = {
    [key]: member.value[key],
  };

  if (key === "full_name") {
    payload[key] = memberFullName.value;
  }

  memberPatch(memberId.value, payload as any)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function selectTab(tab: TabActiveType) {
  router.push(`/members/${memberId.value}/${tab}`);
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("article", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_unref(breadcrumbSimple), {
            items: breadcrumbList.value,
            "show-home": true,
            "url-home": "/home",
            active: "edit"
          }, null, 8, ["items"])
        ]),
        _createElementVNode("section", _hoisted_3, [
          _createVNode(_unref(tabMenu), {
            tabs: tabList.value,
            tooltip: false,
            active: "edit",
            width: "fit-content",
            "padding-inline": "1.5rem",
            "onSelect:tab": selectTab
          }, {
            content: _withCtx(() => [
              (member.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(baseAvatar), {
                        position: "center",
                        "is-edit": false,
                        "show-image": true,
                        url: member.value?.avatar?.large
                      }, null, 8, ["url"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(baseInput), {
                        modelValue: memberFullName.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((memberFullName).value = $event)),
                        value: memberFullName.value,
                        placeholder: _unref(t)('common.placeholders.name'),
                        required: true,
                        "max-length": 75,
                        onBlur: _cache[1] || (_cache[1] = ($event: any) => (updateMember('full_name')))
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value", "placeholder"]),
                      _createVNode(_unref(baseSelect), {
                        modelValue: member.value.active,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((member.value.active) = $event)),
                        value: member.value.active,
                        options: activeOptions.value,
                        "is-empty": false,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (updateMember('active')))
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.active")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value", "options"]),
                      _createVNode(_unref(baseInput), {
                        modelValue: member.value.login,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((member.value.login) = $event)),
                        value: member.value.login,
                        placeholder: _unref(t)('common.placeholders.login'),
                        required: true,
                        "max-length": 75,
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (updateMember('login')))
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.login")) + " * ", 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value", "placeholder"]),
                      _createVNode(_unref(baseInput), {
                        modelValue: member.value.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((member.value.email) = $event)),
                        value: member.value.email,
                        placeholder: _unref(t)('common.placeholders.email'),
                        required: true,
                        "max-length": 50,
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (updateMember('email')))
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value", "placeholder"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["tabs"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})